module.exports = __webpack_public_path__ + "img/bg-mision-2-4.fa41ddcb.jpg";